<div class="content">
  <div class="content-left" [class.m-small]="contentLeftCollapsed()">
    <div class="content-left-inner">
      <app-side-nav></app-side-nav>
      <div class="content-left-bottom-container">
        <button class="toggle-content-left-button" (click)="toggleSideContentCollapse()" [class.m-rotated]="contentLeftCollapsed()">
          <span [innerHTML]="doubleArrowsIcon"></span>
        </button>
      </div>
    </div>
  </div>
  <div class="content-right">
    @if (!hideHeader) {
      <app-header class="container header"></app-header>
    }
    <router-outlet></router-outlet>
  </div>
</div>
